var React = require('react');

function CheckV2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.86329 18.0001C9.58729 18.0001 9.32329 17.8861 9.13429 17.6851L4.27129 12.5061C3.89229 12.1041 3.91329 11.4711 4.31529 11.0931C4.71829 10.7151 5.35129 10.7351 5.72829 11.1371L9.85329 15.5281L18.2613 6.32611C18.6353 5.91711 19.2673 5.89011 19.6753 6.26211C20.0823 6.63411 20.1103 7.26711 19.7383 7.67411L10.6013 17.6741C10.4143 17.8801 10.1483 17.9981 9.87029 18.0001H9.86329Z"}));
}

CheckV2.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckV2;

CheckV2.default = CheckV2;
